import { render, staticRenderFns } from "./InspectionTestList.vue?vue&type=template&id=4a6c20df&scoped=true&"
import script from "./InspectionTestList.vue?vue&type=script&lang=js&"
export * from "./InspectionTestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6c20df",
  null
  
)

export default component.exports